import { typeSchema } from '../types';

export function parseType(value: unknown) {
  const result = typeSchema.safeParse(value);

  if (!result.success) {
    return undefined;
  }

  return result.data;
}
